/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Article_Published_FailedInputs */

const en_toast_article_published_failed = /** @type {(inputs: Toast_Article_Published_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to publish article`)
};

const nl_toast_article_published_failed = /** @type {(inputs: Toast_Article_Published_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fout bij het publiceren van artikel`)
};

/**
* | output |
* | --- |
* | "Failed to publish article" |
*
* @param {Toast_Article_Published_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_article_published_failed = /** @type {((inputs?: Toast_Article_Published_FailedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Article_Published_FailedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_article_published_failed(inputs)
	return en_toast_article_published_failed(inputs)
});